import React from "react";
import { Link } from "react-router-dom";
import { Download, Mail } from "lucide-react";
import PageLayout from "./PageLayout";
import { IMG } from "../data/mock";

export default function PressPage() {
  return (
    <PageLayout
      title="Press"
      subtitle="Resources for journalists, bloggers, and storytellers covering Life With Abba."
    >
      <div className="max-w-3xl mx-auto px-5 py-14 md:py-20">
        <div className="space-y-6 font-serif-body text-[#444] text-[17px] leading-[1.9]">
          <p>
            <strong className="text-[#68c2d5]">Life With Abba</strong> is a private,
            faith-centered journaling app that helps people share the everyday
            moments of their lives — photos, videos, scripture, writing, voice,
            and moods — with God, their Heavenly Father.
          </p>
          <p>
            For interviews, review access, or additional information, our team is
            happy to help. We can provide founder quotes, product background, and
            high-resolution assets on request.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div className="rounded-[10px] border border-[#d7e6ea] p-6 flex items-start gap-4">
            <span className="w-11 h-11 rounded-full bg-[#eaf6f8] flex items-center justify-center shrink-0">
              <Download size={20} className="text-[#0f9fbc]" />
            </span>
            <div>
              <p className="font-serif-body text-[#333] font-bold">Brand Assets</p>
              <p className="font-serif-body text-[#666] text-[14px] mt-1">
                Logos, app screenshots, and brand guidelines available on request.
              </p>
            </div>
          </div>
          <div className="rounded-[10px] border border-[#d7e6ea] p-6 flex items-start gap-4">
            <span className="w-11 h-11 rounded-full bg-[#eaf6f8] flex items-center justify-center shrink-0">
              <Mail size={20} className="text-[#0f9fbc]" />
            </span>
            <div>
              <p className="font-serif-body text-[#333] font-bold">Media Inquiries</p>
              <p className="font-serif-body text-[#666] text-[14px] mt-1">
                press@lifewithabba.com
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10">
          <Link
            to="/contact"
            className="inline-block bg-[#0f9fbc] hover:bg-[#008da9] text-white font-serif-body px-6 py-3 rounded-[4px] transition-colors"
          >
            Contact Our Team
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
